var _linearGradient, _path, _polygon, _polygon2, _polygon3, _polygon4, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Screw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2uy8t5GhrPRxVrCfL6zSa",
    x1: 19.621,
    x2: 19.621,
    y1: 16.359,
    y2: 34.786,
    gradientTransform: "rotate(45.001 27.329 31.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#484b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#66737e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#9fa7b0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e2uy8t5GhrPRxVrCfL6zSa)",
    d: "M12.186,43.592L36.228,19.55l-7.778-7.778L4.408,35.814c-0.781,0.781-0.781,2.047,0,2.828 l4.95,4.95C10.139,44.373,11.405,44.373,12.186,43.592z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a858f",
    points: "14.308,41.471 5.115,35.107 7.237,32.985 16.429,39.349"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a858f",
    points: "18.55,37.228 9.358,30.864 11.479,28.743 20.672,35.107"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a858f",
    points: "22.793,32.985 13.601,26.621 15.722,24.5 24.914,30.864"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a858f",
    points: "27.036,28.743 17.843,22.379 19.964,20.257 29.157,26.621"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2uy8t5GhrPRxVrCfL6zSb",
    x1: 14.886,
    x2: 25.697,
    y1: 10.575,
    y2: 16.232,
    gradientTransform: "rotate(45.001 27.329 31.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e2uy8t5GhrPRxVrCfL6zSb)",
    d: "M41.885,9.651l-0.707-0.707l-1.768,1.768c-0.586,0.586-1.536,0.586-2.121,0 c-0.586-0.586-0.586-1.536,0-2.121l1.768-1.768l-0.707-0.707c-3.905-3.905-10.237-3.905-14.142,0l0,0 c-0.391,0.391-0.391,1.024,0,1.414l16.263,16.263c0.391,0.391,1.024,0.391,1.414,0l0,0C45.79,19.888,45.79,13.556,41.885,9.651z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Screw);
export default __webpack_public_path__ + "static/media/icons8-screw.e6d5ebe44326380c295ee270226365aa.svg";
export { ForwardRef as ReactComponent };